import { render } from "./TownMeeting.vue?vue&type=template&id=fc38378a&scoped=true"
import script from "./TownMeeting.vue?vue&type=script&lang=js"
export * from "./TownMeeting.vue?vue&type=script&lang=js"

import "./TownMeeting.vue?vue&type=style&index=0&id=fc38378a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc38378a"]])

export default __exports__